import type { MoneyV2 } from "./types.generated.ts";

function formatMoney({ currencyCode, amount }: MoneyV2) {
	const parts = new Intl.NumberFormat(
		undefined, // Auto-detect/use the viewer's locale
		{
			style: "currency",
			currency: currencyCode,
			// narrowSymbol only supported by some. Use symbol in that case. Throws RangeError.
			// Have solved by having a polyfill in website and creator.
			currencyDisplay: "narrowSymbol",
		},
	).formatToParts(parseFloat(amount));

	const nonCurrencyParts = parts.filter((p) => p.type !== "currency");
	const symbol = parts.find((p) => p.type === "currency")?.value ?? "";
	const formattedAmount = nonCurrencyParts.map((p) => p.value).join("");
	if (symbol === currencyCode) {
		return formattedAmount;
	}
	return symbol + formattedAmount;
}

export { formatMoney };
